// @flow

import _ from 'lodash';
import gql from 'graphql-tag';

import { graphql } from '@apollo/react-hoc'; // eslint-disable-line no-restricted-syntax

import SplitLoginPage from 'app/login/components/SplitLoginPage';
import maybeRender from 'app/common/components/maybeRender';

type OwnProps = {
  selectedApis: Array<string>,
};

const oneServiceSplitLoginPageQuery = gql`
  query oneServiceSplitLoginPageQuery($headImplementationId: ID!) {
    headService: appImplementationById(id: $headImplementationId) {
      id
      key: id
      name
    }
  }
`;

export default _.flowRight(
  graphql(oneServiceSplitLoginPageQuery, {
    options: (props: OwnProps) => {
      const { selectedApis } = props;
      const s1 = selectedApis[0];

      return {
        variables: {
          headImplementationId: s1,
        },
      };
    },
  }),
  maybeRender(props => !props.data.loading)
)(SplitLoginPage);
